Controller.$inject = [];

function Controller() {

}

export function HuiStepper() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            color: '@',
            orientation: '@'
        },
        controller: Controller,
        controllerAs: '$huiStepper',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="hui hui-stepper"
                    ng-class="['hui-' + ($huiStepper.color || 'accent'),
                               ($huiStepper.orientation || 'horizontal')]">
                    <div class="hui-stepper-list" ng-transclude></div>
                </div>
            `;
        }
    };
}